import PropTypes from 'prop-types'
import { Box, IconButton } from '@mui/material'
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded'
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded'
import { useIntl } from 'react-intl'
import { not } from 'ramda'
import GA from 'services/gaService'
import { useFavoriteMutation } from 'api/cardsApi'
import useAnalytics from 'hooks/useAnalytics'

const Bookmark = ({ id, isBookmarked, params }) => {
  const { formatMessage } = useIntl()
  const { sendEvent } = useAnalytics()

  const [favorite] = useFavoriteMutation()

  const handleClick = () => {
    favorite({
      card_id: id,
      isFavorite: not(isBookmarked)
    })
    // GA tracking for our event
    if (not(isBookmarked)) {
      GA.click('Favorite-Card', 'Click')
      sendEvent('card_detail_view_favorite', { ...params })
    } else {
      GA.click('Unfavorite-Card', 'Click')
      sendEvent('card_detail_view_unfavorite', { ...params })
    }
  }

  return (
    <IconButton
      aria-label={
        isBookmarked
          ? formatMessage({
              defaultMessage: 'Favorite, Selected',
              id: 'E1dwhN'
            })
          : formatMessage({
              defaultMessage: 'Favorite, Not Selected',
              id: 'XDa+uB'
            })
      }
      onClick={handleClick}
    >
      <Box
        sx={{
          display: 'flex',
          fill: isBookmarked ? 'school.secondary' : 'primary.dark'
        }}
      >
        {isBookmarked ? (
          <FavoriteRoundedIcon color="inherit" />
        ) : (
          <FavoriteBorderRoundedIcon color="inherit" />
        )}
      </Box>
    </IconButton>
  )
}

Bookmark.propTypes = {
  id: PropTypes.number.isRequired,
  isBookmarked: PropTypes.bool.isRequired,
  params: PropTypes.shape({}).isRequired
}

export default Bookmark
